<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
</div>
<!-- progress bar starts -->
<div class="background-style">
    <div class="progress ie-padding">
        <div class="circle done"> <span class="label">1</span>
            <p class="title-span-1">Site</p>
        </div> <span class="bar done"></span>

        <div class="circle"> <span class="label">2</span>
            <p class="title-span-2">ERG</p>
        </div> <span class="bar done"></span>


        <div class="circle"> <span class="label">3</span>
            <p class="title-span-3 ie-span-3">Areas of Impact</p>
        </div> <span class="bar"></span>

        <div class="circle"> <span class="label">4</span>
            <p class="title-span-4">Skills/interests</p>
        </div>
    </div>
    <!-- progress bar ends -->

    <!-- membership list starts -->
    <div class="noData" *ngIf="nositefound">No site found</div>

    <div *ngIf="!nositefound" class="div">

        <div class="heading ">
            Please select desired site
        </div>
        <div class="redFont text-center">
            <em>
                <strong class="pr-1">Note:</strong>
            </em>
            <span>
                <em>
                    You can either select your default site for regular membership or select other sites for virtual
                    memberships.
                </em>
            </span>
        </div>

        <div class="row music-covers-listing videos-list align-row width-horizontal">
            <div class="col-md-6 div-top" *ngFor="let site of siteList">
                <label class="font-family phone-style">
                    <input type="radio" name="radio" [checked]="site.checked" (change)="toggleRadio($event,site)">
                    <span class="label-text"></span>
                    <span class="label-style checkbox-style">{{site.siteName}}
                        <span class="redFont ml-1" *ngIf="defaultSite == site.siteName">(default site)</span>
                        <span class="redFont ml-1" *ngIf="site.isRegistered">(registered site)</span>
                    </span>
                </label>
            </div>
        </div>

        <p class="alert-class">{{message}}</p>
        <p class="top-space text-center margin-bottom">

            <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button"
                (click)="sendData()">NEXT</button>
        </p>
    </div>
    <!-- membership list ends -->
</div>
